import React from 'react';
import { Button } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import BarChartIcon from '@mui/icons-material/BarChart';
import styles from '../../pages/orders-module/orders-component/orders-component.module.scss';
import { useTranslation } from 'react-i18next';

const SurveyReportGridViewToggle = ({ isGrid, setGridView, testId }) => {
    const { t } = useTranslation();

    return (
        <div className={`${styles.surveyReportToggleButton} routing-container`}>
            <div>
                <Button
                    data-testid={testId}
                    variant={isGrid ? "contained" : "text"}
                    sx={{
                        color: !isGrid
                            ? "var(--color-dimgray) !important"
                            : "var(--bg-white) !important",
                        backgroundColor: !isGrid
                            ? "var(--bg-white) !important"
                            : "var(--color-base) !important",
                        borderRadius: !isGrid ? "100%" : "10px",
                        width: !isGrid ? "70px" : "80px",
                        height: "30px",
                        transition: "none !important",
                        fontSize: "var(--common-heading)",
                    }}
                    onClick={() => setGridView(!isGrid)}
                >
                    <BarChartIcon />
                    <span className={styles.commonContent}>
                        {t("reports.charts")}
                    </span>
                </Button>
            </div>
            <div onClick={() => { setGridView(!isGrid); localStorage.setItem("lastPage", JSON.stringify(testId)); }}>
                <Button
                    variant={!isGrid ? "contained" : ""}
                    sx={{
                        color: !isGrid
                            ? "var(--bg-white) !important"
                            : "var(--color-dimgray) !important",
                        backgroundColor: !isGrid
                            ? "var(--color-base) !important"
                            : "var(--bg-white) !important",
                        borderRadius: isGrid ? "100%" : "10px",
                        width: isGrid ? "70px" : "80px",
                        height: "30px",
                        transition: "none !important",
                        fontSize: "var(--common-heading)",
                    }}
                >
                    <ArticleOutlinedIcon />
                    <span className={styles.commonContent}>
                        {t("reports.details")}
                    </span>
                </Button>
            </div>
        </div>
    );
};

export default SurveyReportGridViewToggle;
